import { getMeta } from '@helpcenter/meta';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';
import CsmRequestDetailsQuery, {
    type csmRequestDetailsQuery,
} from '../../ui/__generated__/csmRequestDetailsQuery.graphql';

export const csmRequestDetailsQueryResource = createRelayResource<csmRequestDetailsQuery>({
    type: 'CSM_REQUEST_DETAILS_QUERY',
    getQuery: (
        {
            match: {
                params: { requestKey },
            },
        },
        { cloudId }
    ) => ({
        parameters: CsmRequestDetailsQuery,
        variables: {
            cloudId,
            issueKey: requestKey ?? '',
            helpCenterId: getMeta('help-center-ari') ?? '',
        },
        options: {
            fetchPolicy: 'store-or-network',
        },
    }),
});
